module.exports = __webpack_public_path__ + "img/outilvert_on.ce4df1a8.gif";